import { HardHat, ArrowLeft, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";

export default function DeleteAccountPage() {
  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4">
      <div className="max-w-2xl mx-auto bg-white rounded-xl border border-slate-200 shadow-sm p-6 sm:p-10 space-y-6">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-md bg-[#0044FF] grid place-items-center">
            <HardHat className="h-6 w-6 text-white" strokeWidth={2.5} />
          </div>
          <h1 className="font-heading font-black text-2xl tracking-tight">
            Eliminazione account — IL-Report
          </h1>
        </div>

        <section className="space-y-4 text-sm text-slate-700 leading-relaxed">
          <p>
            Puoi richiedere in qualsiasi momento l'eliminazione del tuo account
            IL-Report e di tutti i dati associati.
          </p>

          <h2 className="font-heading font-bold text-lg flex items-center gap-2">
            <Trash2 className="h-5 w-5 text-red-600" /> Come richiedere l'eliminazione
          </h2>
          <ol className="list-decimal ml-5 space-y-2">
            <li>
              Invia un'email a{" "}
              <a className="underline font-bold" href="mailto:ivan.lollio@gmail.com?subject=Richiesta%20eliminazione%20account%20IL-Report">
                ivan.lollio@gmail.com
              </a>{" "}
              con oggetto <b>"Richiesta eliminazione account IL-Report"</b>
            </li>
            <li>Indica l'<b>email con cui accedi</b> all'app e il nome della tua azienda</li>
            <li>Riceverai conferma dell'avvenuta eliminazione entro <b>30 giorni</b></li>
          </ol>

          <h2 className="font-heading font-bold text-lg">Quali dati vengono eliminati</h2>
          <p>
            Con l'eliminazione dell'account vengono cancellati definitivamente: dati
            di accesso (nome, email, password), e — se sei il titolare dell'azienda —
            tutti i dati aziendali (dipendenti, rapportini, ore, commesse, clienti).
          </p>

          <h2 className="font-heading font-bold text-lg">Dati conservati temporaneamente</h2>
          <p>
            Le ricevute di pagamento possono essere conservate per gli obblighi
            fiscali di legge (10 anni), in forma minimizzata. Nessun altro dato
            viene conservato dopo l'eliminazione.
          </p>
        </section>

        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-[#0044FF] underline" data-testid="delete-account-back-link">
          <ArrowLeft className="h-3.5 w-3.5" /> Torna all'app
        </Link>
      </div>
    </div>
  );
}
